const appSandbox = {
  nbContactsToBeAnAppBoss: 1, // If the # of contacts is 2, the user is an App Boss
  configVersion: "Sandbox",
};

export {
  appSandbox,
};

